// extracted by mini-css-extract-plugin
export var cardLayout = "_65-1";
export var paginationContainer = "_65-0";